module.exports = __webpack_public_path__ + "static/media/luminatouch-2.f5edb0ca.jpg";